const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

// UI COMPONENTS ==============================================================
import MiniCart from './components/ui/cart/MiniCart';
import QuickSearch from './components/ui/QuickSearch';
import PredictiveSearch from './components/ui/PredictiveSearch';

// NAV COMPONENTS ==============================================================
import DesktopNav from './components/nav/DesktopNav';
import MobileNav from './components/nav/MobileNav';


// MEDIA COMPONENTS -----------------------------------------------------------

export const AppComponents = {
  // Content Components ------------------------------------------------------------
  ProductForm: asyncComponentFactory('product/ProductForm'),
  ProductFormOld: asyncComponentFactory('product/ProductFormOld'),
  ProductGallery: asyncComponentFactory('product/ProductGallery'),
  ProductSelector: asyncComponentFactory('product/ProductSelector'),
  CrossSell: asyncComponentFactory('product/CrossSell'),

  // MEDIA Components ------------------------------------------------------------
  MediaWrapper: asyncComponentFactory('media/MediaWrapper'),

  // UI Components ------------------------------------------------------------
  MiniCart,
  Modal: asyncComponentFactory('ui/Modal'),
  Slider: asyncComponentFactory('ui/Slider'),
  Accordion: asyncComponentFactory('ui/Accordion'),
  Drawer: asyncComponentFactory('ui/Drawer'),
  Tabs: asyncComponentFactory('ui/Tabs'),
  StaffCard: asyncComponentFactory('ui/StaffCard'),
  MobileSearch: asyncComponentFactory('ui/MobileSearch'),
  MobileFilters: asyncComponentFactory('ui/MobileFilters'),
  BlogFilter: asyncComponentFactory('ui/BlogFilter'),
  LazyLoader: asyncComponentFactory('ui/LazyLoader'),
  QuantitySelector: asyncComponentFactory('ui/cart/QuantitySelector'),
  DiscountInput: asyncComponentFactory('ui/cart/DiscountInput'),
  BackToTop: asyncComponentFactory('ui/BackToTop'),
  DesktopSearch: asyncComponentFactory('ui/DesktopSearch'),
  ScrollableTable: asyncComponentFactory('ui/ScrollableTable'),
  CollectionMain: asyncComponentFactory('ui/CollectionMain'),
  SearchMain: asyncComponentFactory('ui/SearchMain'),
  AutoComplete: asyncComponentFactory('ui/AutoComplete'),
  CustomSelect: asyncComponentFactory('ui/CustomSelect'),
  CookiesConsent: asyncComponentFactory('ui/CookiesConsent'),

  // NAV Components ------------------------------------------------------------
  DesktopNav,
  MobileNav,
  QuickSearch,
  PredictiveSearch,
  CollectionSort: asyncComponentFactory('nav/CollectionSort'),
  BrandsNav: asyncComponentFactory('nav/BrandsNav')
};
